import { Label, Stack, Text } from '@fluentui/react';
import React from 'react';
import IvicosStrings from 'kits/language/stringKit';
import { IvicosColors } from 'kits/colorKit';
import { hardcodedAddOns } from 'features/Rooms/RoomView/addons';
import { useRecoilState } from 'recoil';
import { aLinkAttachmentItemId, aLinkAttachmentModalBox } from 'features/LinkAttachmentModalBox/atom';
import { useCurrentAreaId, useCurrentCampusId, useCurrentRoomId } from 'shared-state/location/hook';
import { resourceService } from 'services/api/resource.service';
import { AttachmentDto } from 'services/client-api-wrapper/campus_api/responses.dto';

const AttachmentTypeSelectionPanel: React.FC<{
    theme: any;
    visibleAttachmentTypes: string[];
    setIsAttachmentCreationModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
    onAttachmentCreation: (attachment?: AttachmentDto | undefined) => void;
}> = (props) => {
    const [, setLinkAttachmentItemId] = useRecoilState(aLinkAttachmentItemId);
    const [, setToggleLinkAttachmentModalBox] = useRecoilState<boolean>(aLinkAttachmentModalBox);

    const { theme, visibleAttachmentTypes, setIsAttachmentCreationModalOpen, onAttachmentCreation } = props;
    const translation = (attachmentName: string, attachmentDescription: string) => {
        if (attachmentName === 'Link') {
            return [IvicosStrings.linkTypeTitle, IvicosStrings.linkTypeDescription];
        } else if (attachmentName === 'Collaboard') {
            return [IvicosStrings.collaboardTypeTitle, IvicosStrings.collaboardTypeDescription];
        } else if (attachmentName === 'Conceptboard') {
            return [IvicosStrings.conceptboardTypeTitle, IvicosStrings.conceptboardTypeDescription];
        } else if (attachmentName === 'Etherpad') {
            return [IvicosStrings.etherpadTypeTitle, IvicosStrings.etherpadTypeDescription];
        } else if (attachmentName === 'Tldraw') {
            return [IvicosStrings.tldrawTypeTitle, IvicosStrings.tldrawTypeDescription];
        } else if (attachmentName === 'YouTube') {
            return [IvicosStrings.youtubeLinkTypeTitle, IvicosStrings.youtubeLinkTypeDescription];
        } else {
            return [attachmentName, attachmentDescription];
        }
    };
    const selectedAddons = hardcodedAddOns
        .filter((item) => visibleAttachmentTypes.includes(item.id))
        .map((addOn) => ({
            displayName: addOn.attributes.displayName,
            description: addOn.attributes.description,
            id: addOn.id,
            icon: addOn.attributes.iconUrl
        }));

    const [campusId] = useCurrentCampusId();
    const [areaId] = useCurrentAreaId();
    const [roomId] = useCurrentRoomId();
    const randomString = (length = 20) => {
        // Declare all characters
        const chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';

        // Pick characers randomly
        let str = '';
        for (let i = 0; i < length; i++) {
            str += chars.charAt(Math.floor(Math.random() * chars.length));
        }

        return str;
    };
    const createAttachment = async (addOnName: string, isPinned?: boolean, optionalRef?: string) => {
        if (!campusId || !areaId || !roomId) return;
        const attachment = await resourceService.createAttachment(
            campusId,
            areaId,
            roomId,
            addOnName,
            optionalRef || randomString(),
            false,
            isPinned ? isPinned : false
        );

        onAttachmentCreation && onAttachmentCreation(attachment);
    };

    const attachmentCreateText = visibleAttachmentTypes.includes('youtubelinkmanager')
        ? IvicosStrings.createLinkAttachmentTitle
        : IvicosStrings.createToolAttachmentTitle;

    return (
        <>
            <Label>{attachmentCreateText}</Label>
            {selectedAddons.map((item) => {
                const [displayName, description] = translation(item.displayName, item.description);
                return (
                    <Stack
                        key={item.id}
                        aria-label="attachments-choose-type"
                        className="pressable"
                        horizontal
                        style={{ padding: 8 }}
                        verticalAlign="center"
                        tokens={{ childrenGap: 8 }}
                        onClick={() => {
                            if (item.id.endsWith('linkmanager')) {
                                setIsAttachmentCreationModalOpen(true);
                                setToggleLinkAttachmentModalBox(true);
                                setLinkAttachmentItemId(item.id);
                                return;
                            }
                            createAttachment(item.id, false);
                        }}
                    >
                        <img src={item.icon || 'https://static-cdn.vercel.app/addon.svg'} height={48} />
                        <Stack>
                            <Text variant="large">{displayName}</Text>
                            <Text variant="small">{description}</Text>
                        </Stack>
                        {item.displayName === 'YouTube' && (
                            <Stack
                                style={{
                                    backgroundColor: IvicosColors.Dunkelblau,
                                    textAlign: 'center',
                                    width: '43%',
                                    borderRadius: '15px',
                                    margin: '8px 0px 11px 0px'
                                }}
                            >
                                <Text variant="small" style={{ color: theme.palette.white, padding: '3.5px 1px', fontWeight: 'bolder' }}>
                                    {IvicosStrings.experimentalLabelTitle}
                                </Text>
                            </Stack>
                        )}
                    </Stack>
                );
            })}
        </>
    );
};
export default AttachmentTypeSelectionPanel;
